"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useBroadcastParams = require("../../hooks/useBroadcastParams");
var _underscore = require("underscore");
var _ = require("../..");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
var _Permissions = require("../../constants/Permissions");
var _Permission = _interopRequireDefault(require("../Permissions/Permission"));
var _PermissionTooltip = _interopRequireDefault(require("../Permissions/PermissionTooltip"));
var _PermissionController = require("../Permissions/PermissionController");
var _RoleNames = require("../../constants/RoleNames");
var _globalTooltipDelay = require("../../utils/globalTooltipDelay");
var _TooltipMessages = require("./TooltipMessages");
var _SourceListItemCtaIcons = require("./SourceListItemCtaIcons.styled");
var _useTranslate2 = require("../../locales/useTranslate");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// permissions

var DEBOUNCE_DELAY = 300;
var getViewPermissions = function getViewPermissions() {
  return [_Permissions.TOGGLE_MUTE];
};
var SourceListItemCtaIcons = function SourceListItemCtaIcons(props) {
  var featured = props.featured,
    muted = props.muted,
    loop = props.loop,
    onFeaturedToggleClicked = props.onFeaturedToggleClicked,
    onMuteToggleClicked = props.onMuteToggleClicked,
    sourceType = props.sourceType,
    onLoopToggleClicked = props.onLoopToggleClicked,
    sourceId = props.sourceId,
    onCameraToggleClicked = props.onCameraToggleClicked,
    isCameraOn = props.isCameraOn,
    isMaximumCameraSourcesOn = props.isMaximumCameraSourcesOn,
    onSourceSetToLive = props.onSourceSetToLive,
    hovered = props.hovered,
    isStagedSourcesActive = props.isStagedSourcesActive,
    isTooltipVisible = props.isTooltipVisible,
    toggleTooltipVisibilityOn = props.toggleTooltipVisibilityOn,
    user = props.user,
    viewPermissions = props.viewPermissions,
    source = props.source,
    layout = props.layout,
    live = props.live,
    maxCameraSourceLimit = props.maxCameraSourceLimit;
  var eventId = (0, _useBroadcastParams.useBroadcastParams)();
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;

  // Memoize translations once on mount for stable references
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var translations = (0, _react.useMemo)(function () {
    var presenterTitle = translate('PresenterTitle_Mic_Popover');
    return {
      MIC_ON: "".concat(presenterTitle, " ").concat(translate('Mic_On_Popover')),
      MIC_OFF: "".concat(presenterTitle, " ").concat(translate('Mic_Off_Popover')),
      CAMERA_ON: "".concat(presenterTitle, " ").concat(translate('Camera_On_Popover')),
      CAMERA_OFF: "".concat(presenterTitle, " ").concat(translate('Camera_Off_Popover')),
      CAMERA_PERMISSION: translate('Camera_Permission_Popover'),
      CAMERA_UNAVAILABLE: translate('Camera_Unavailable_Popover'),
      VOLUME_OFF: translate((0, _TooltipMessages.getVolumeOffMessage)()),
      VOLUME_ON: translate((0, _TooltipMessages.getVolumeOnMessage)()),
      LOOP: translate((0, _TooltipMessages.getLoopMessage)()),
      FEATURED: translate((0, _TooltipMessages.getFeaturedSourceText)()),
      SOLO: translate((0, _TooltipMessages.getSoloMessage)())
    };
  }, [translate]);
  var MIC_ON = translations.MIC_ON;
  var MIC_OFF = translations.MIC_OFF;
  var CAMERA_ON = translations.CAMERA_ON;
  var CAMERA_OFF = source.cameraUnavailable ? source.user === user._id ? translations.CAMERA_PERMISSION : translations.CAMERA_UNAVAILABLE : translations.CAMERA_OFF;
  var throttlePropagation = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
  }, []);
  var debouncedMuteToggle = (0, _react.useMemo)(function () {
    return (0, _underscore.debounce)(function () {
      return onMuteToggleClicked();
    }, DEBOUNCE_DELAY);
  }, [onMuteToggleClicked]);
  var debouncedCameraToggle = (0, _react.useMemo)(function () {
    return (0, _underscore.debounce)(function () {
      return onCameraToggleClicked();
    }, DEBOUNCE_DELAY);
  }, [onCameraToggleClicked]);
  var displayPermissionTooltip = (0, _react.useCallback)(function (enableFeature, targetElementId, canToggleCamera) {
    return /*#__PURE__*/_react["default"].createElement(_PermissionTooltip["default"], {
      displayTooltip: !enableFeature && !canToggleCamera,
      targetElementId: targetElementId,
      requiredRole: "Admin or show caller"
    });
  }, []);
  var displayVideoMediaControls = (0, _react.useCallback)(function (enableFeature) {
    var targetElementId = 'video-media-controls';
    var loopIconId = "loop-icon-".concat(sourceId);
    var volumeIconId = "volume-icon-".concat(sourceId);
    var volumeTooltipMessage = muted ? translations.VOLUME_OFF : translations.VOLUME_ON;
    return /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.IconContainer, {
      id: targetElementId,
      $isHovered: hovered,
      onMouseLeave: toggleTooltipVisibilityOn
    }, hovered && /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.IconWrapper, {
      id: loopIconId
    }, /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.StyledTransparentIcon, {
      active: loop,
      activeIcon: _freeSolidSvgIcons.faRepeat,
      inactiveIcon: _freeSolidSvgIcons.faRepeat,
      iconColor: !loop ? '#fff' : '#33373d',
      enableFeature: enableFeature,
      screenReaderText: "Loop Media Source",
      onClick: enableFeature ? onLoopToggleClicked : throttlePropagation,
      ddActionName: "Loop ".concat(sourceType, " source - ").concat(sourceId)
    }), enableFeature && isTooltipVisible && /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: loopIconId,
      message: translations.LOOP
    })), /*#__PURE__*/_react["default"].createElement("div", {
      id: volumeIconId
    }, /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.StyledSolidIcon, {
      activeIcon: _freeSolidSvgIcons.faVolumeUp,
      inactiveIcon: _freeSolidSvgIcons.faVolumeMute,
      active: !muted,
      enableFeature: enableFeature,
      iconColor: muted ? '#de2f1b' : '#33373d',
      screenReaderText: "Mute Media Source",
      "data-testid": "mute-media-source-".concat(sourceId),
      ddActionName: "".concat(muted ? 'Unmute' : 'Mute', " ").concat(sourceType, " source - ").concat(sourceId),
      onClick: enableFeature ? onMuteToggleClicked : throttlePropagation
    }), enableFeature && isTooltipVisible && /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: volumeIconId,
      message: volumeTooltipMessage
    })), displayPermissionTooltip(enableFeature, targetElementId));
  }, [sourceId, hovered, toggleTooltipVisibilityOn, loop, onLoopToggleClicked, sourceType, isTooltipVisible, muted, onMuteToggleClicked, displayPermissionTooltip, throttlePropagation, translations.VOLUME_OFF, translations.VOLUME_ON, translations.LOOP]);
  var displayMuteComponent = (0, _react.useCallback)(function (enableFeature) {
    var targetElementId = "mute-toggle-".concat(sourceId);
    var muteIconClickHandler = enableFeature ? debouncedMuteToggle : throttlePropagation;
    var toolTipMessage = muted ? MIC_OFF : MIC_ON;
    return /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.StyledPermissionWrapper, {
      id: targetElementId,
      "data-testid": muted ? 'microphone-button-unmute' : 'microphone-button-mute',
      enableFeature: enableFeature,
      onMouseLeave: toggleTooltipVisibilityOn
    }, /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.StyledSolidIcon, {
      active: !muted,
      activeIcon: _freeSolidSvgIcons.faMicrophoneAlt,
      onClick: muteIconClickHandler,
      enableFeature: enableFeature,
      screenReaderText: "Mute Source",
      inactiveIcon: _freeSolidSvgIcons.faMicrophoneAltSlash,
      iconColor: muted ? '#de2f1b' : '#33373d',
      currentUserRole: (0, _PermissionController.extractUserRole)(user, eventId),
      "aria-pressed": !muted,
      ddActionName: "".concat(muted ? 'Unmute' : 'Mute', " ").concat(sourceType, " source - ").concat(sourceId)
    }), enableFeature && isTooltipVisible && /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: targetElementId,
      message: toolTipMessage
    }), displayPermissionTooltip(enableFeature, targetElementId));
  }, [sourceId, throttlePropagation, muted, MIC_OFF, MIC_ON, toggleTooltipVisibilityOn, user, eventId, sourceType, isTooltipVisible, displayPermissionTooltip, debouncedMuteToggle]);
  var displayFeaturedIcon = (0, _react.useCallback)(function (enableFeature) {
    var targetElementId = "featured-toggle-".concat(sourceId);
    var featuredClickHandler = enableFeature ? onFeaturedToggleClicked : throttlePropagation;
    return /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.IconWrapper, {
      id: targetElementId,
      onMouseLeave: toggleTooltipVisibilityOn
    }, /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.StyledTransparentIcon, {
      screenReaderText: "Feature presenter",
      active: featured,
      onClick: featuredClickHandler,
      activeIcon: _freeSolidSvgIcons.faThumbTack,
      inactiveIcon: _proSolidSvgIcons.faThumbTack,
      enableFeature: enableFeature,
      currentUserRole: (0, _PermissionController.extractUserRole)(user, eventId),
      ddActionName: "Feature presenter - ".concat(sourceId)
    }), enableFeature && isTooltipVisible ? /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: targetElementId,
      message: translations.FEATURED
    }) : displayPermissionTooltip(enableFeature, targetElementId));
  }, [sourceId, onFeaturedToggleClicked, throttlePropagation, toggleTooltipVisibilityOn, featured, user, eventId, isTooltipVisible, displayPermissionTooltip, translations.FEATURED]);
  var displayVideoToggleComponent = (0, _react.useCallback)(function (enableFeature) {
    var targetElementId = "camera-toggle-".concat(sourceId);
    var toolTipMessage = isCameraOn ? CAMERA_ON : CAMERA_OFF;
    var userRole = (0, _PermissionController.extractUserRole)(user, eventId);
    var canToggleCamera = (userRole && userRole.toLowerCase()) !== _RoleNames.ROLE_NAME_CONTRIBUTOR.toLowerCase();
    var maxCameraMessage = "All ".concat(maxCameraSourceLimit, " of ").concat(maxCameraSourceLimit, " cameras are in use");
    var videoClickHandler = isMaximumCameraSourcesOn && !isCameraOn || !canToggleCamera ? throttlePropagation : debouncedCameraToggle;
    if (!enableFeature || source.cameraUnavailable) {
      videoClickHandler = throttlePropagation;
    }
    return /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.IconWrapper, {
      id: targetElementId,
      onMouseLeave: toggleTooltipVisibilityOn
    }, /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.StyledVideoIcon, {
      active: isCameraOn,
      activeIcon: _freeSolidSvgIcons.faVideo,
      cameraUnavailable: source.cameraUnavailable,
      inactiveIcon: _freeSolidSvgIcons.faVideoSlash,
      enableFeature: enableFeature && canToggleCamera,
      screenReaderText: "Camera Status",
      iconColor: isCameraOn ? '#33373d' : '#de2f1b',
      "data-testid": "camera-toggle-".concat(sourceId),
      isMaximumCameraSourcesOn: isMaximumCameraSourcesOn,
      onClick: videoClickHandler,
      currentUserRole: (0, _PermissionController.extractUserRole)(user, eventId),
      canToggleCamera: canToggleCamera,
      ddActionName: "Turn Camera Status ".concat(isCameraOn ? 'Off' : 'On', " for ").concat(sourceType, " source - ").concat(sourceId)
    }), isTooltipVisible && /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: "camera-toggle-".concat(sourceId),
      message: isMaximumCameraSourcesOn && !isCameraOn ? maxCameraMessage : toolTipMessage
    }), displayPermissionTooltip(enableFeature, targetElementId, canToggleCamera));
  }, [sourceId, isCameraOn, CAMERA_ON, CAMERA_OFF, user, eventId, isMaximumCameraSourcesOn, throttlePropagation, source.cameraUnavailable, toggleTooltipVisibilityOn, sourceType, isTooltipVisible, displayPermissionTooltip, maxCameraSourceLimit, debouncedCameraToggle]);
  var SoloIcon = function SoloIcon() {
    var targetElementId = "solo-toggle-".concat(sourceId);
    var iconShouldBeActive = live && layout === _.SINGLE.id;
    return /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.IconWrapper, {
      id: targetElementId,
      onMouseLeave: toggleTooltipVisibilityOn
    }, /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.StyledSoloIcon, {
      $isStagedSourcesActive: isStagedSourcesActive,
      screenReaderText: "Solo",
      active: iconShouldBeActive,
      onClick: onSourceSetToLive,
      activeIcon: _freeSolidSvgIcons.faMaximize,
      inactiveIcon: _freeSolidSvgIcons.faMaximize,
      enableFeature: true,
      currentUserRole: (0, _PermissionController.extractUserRole)(user, eventId),
      ddActionName: "Solo ".concat(sourceType, " source - ").concat(sourceId)
    }), !isStagedSourcesActive && isTooltipVisible && /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
      placement: 'top',
      delay: _globalTooltipDelay.TOOL_TIP_DELAY,
      target: targetElementId,
      message: translations.SOLO,
      noPointerEvent: true
    }));
  };
  var presenterIcons = /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.IconContainer, {
    $isHovered: hovered
  }, hovered && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayFeaturedIcon,
    user: user,
    viewPermissions: viewPermissions
  }), /*#__PURE__*/_react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayVideoToggleComponent,
    user: user,
    viewPermissions: viewPermissions
  })), /*#__PURE__*/_react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayMuteComponent,
    user: user,
    viewPermissions: viewPermissions
  }));
  var mediaIcons = /*#__PURE__*/_react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayVideoMediaControls,
    user: user,
    viewPermissions: viewPermissions
  });
  var isSoloIconVisible = hovered && sourceType !== _.AUDIO_FILE;
  if (sourceType === _.MEDIA) return null;
  return /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.StyledSection, null, /*#__PURE__*/_react["default"].createElement("div", null, isSoloIconVisible && /*#__PURE__*/_react["default"].createElement(SoloIcon, {
    onClick: onSourceSetToLive
  })), /*#__PURE__*/_react["default"].createElement(PresentationActivePage, {
    source: source
  }), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, sourceType === _.CAMERA_PRESENTER && presenterIcons, [_.VIDEO_FILE, _.AUDIO_FILE].includes(sourceType) && mediaIcons));
};
SourceListItemCtaIcons.propTypes = {
  sourceType: _propTypes["default"].string,
  featured: _propTypes["default"].bool,
  onFeaturedToggleClicked: _propTypes["default"].func,
  muted: _propTypes["default"].bool,
  onMuteToggleClicked: _propTypes["default"].func,
  loop: _propTypes["default"].bool,
  onLoopToggleClicked: _propTypes["default"].func,
  sourceId: _propTypes["default"].string,
  onCameraToggleClicked: _propTypes["default"].func,
  isCameraOn: _propTypes["default"].bool,
  isMaximumCameraSourcesOn: _propTypes["default"].bool,
  onSourceSetToLive: _propTypes["default"].func,
  hovered: _propTypes["default"].bool,
  isStagedSourcesActive: _propTypes["default"].bool,
  isTooltipVisible: _propTypes["default"].bool,
  toggleTooltipVisibilityOn: _propTypes["default"].func,
  user: _propTypes["default"].object,
  viewPermissions: _propTypes["default"].object,
  source: _propTypes["default"].object,
  maxCameraSourceLimit: _propTypes["default"].number
};
var PresentationActivePage = function PresentationActivePage(_ref) {
  var source = _ref.source;
  var type = source.type,
    _source$value$activeP = source.value.activePage,
    activePage = _source$value$activeP === void 0 ? 1 : _source$value$activeP;
  if (type !== _.PDF_FILE) return null;
  return /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.ActivePageContainer, {
    "data-testid": "presentation-active-page"
  }, /*#__PURE__*/_react["default"].createElement(_SourceListItemCtaIcons.ActivePage, null, activePage));
};
PresentationActivePage.propTypes = {
  source: _propTypes["default"].shape({
    value: _propTypes["default"].shape({
      activePage: _propTypes["default"].string
    }),
    type: _propTypes["default"].string
  })
};
var _default = exports["default"] = SourceListItemCtaIcons;